export { NileTag_2 } from './nile-tag-2';
